const actions = {
  /** 表示 */
  DISP({ commit }) {
    const payload = {
      isVisible: true,
    }
    commit('SET', payload)
  },
  /** 非表示 */
  HIDE({ commit }) {
    const payload = {
      isVisible: false,
    }
    commit('SET', payload)
  },
}

export default actions
